import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
import SideBarNew from "../../SideBarNew";
import TopBarNew from "../../TopBarNew";
import MenuIcon from "../../icons/MenuIcon.svg";
import TowerIcon2 from "../../icons/TowerIcon2.svg";
import { activesubscription } from "../../redux";
import Search from "../../Icon/Search.png";
import TableView from "../../ReusableComponents/TableView/TableView.js";
import ButtonWithIcon from "../../ReusableComponents/ButtonWithIcon.js";
import LoaderComponent from "../../ReusableComponents/LoaderComponent.js";
import whitePlus from "../../assets/Icons/whiteplus.png";
import CreateTowerPlan from "./CreateTowerPlan.js";
import * as API from "../../api.js";
import { useHistory } from "react-router-dom";
import KMLViewer from "./KMLViewer.js";
import { Modal } from "react-bootstrap";
import { downloadReport } from "../../utils.js";
import { breadcrumbsClasses } from "@mui/material";
import toast, { Toaster } from "react-hot-toast";

const TowerPlan = (props) => {
  const [user, setUser] = useState({ username: "Guest" });
  const [type, setType] = useState("viewer");
  const [sidebarMode, setSidebarMode] = useState("shrunk");
  const [showBackIcon, setShowBackIcon] = useState(true);
  const [globalState, setGlobalState] = useState({ selectView: "list" });
  const [tableState, setTableState] = useState({ pageSize: 10, pageNumber: 1 });
  const [isLoading, setIsLoading] = useState(false);
  const [projects, setProjects] = useState([]);
  const [counts, setCounts] = useState(0);
  const location = useLocation();
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const history = useHistory();
  const { rowData } = location?.state || {};
  const [fetchReport, setFetchReport] = useState(false);
  const [plans, setAllPlans] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState({});
  const [kmlUrl, setKmlUrl] = useState("");
  const [reportDetails, setReportDetails] = useState();
  const query = new URLSearchParams(useLocation().search);
  const fromDashBoard = query.get("fromDashBoard") === "true" || false;
  const [searchKey, setSearchKey] = useState("");
  const [showRegeneratePopup, setShowRegeneratePopup] = useState(false);
  const isTowerPresent = plans.length > 0 ? true : false;
  

  const columns = [
    { Header: "Name", accessor: "plan_name" },
    { Header: "Created", accessor: "date_and_time", isSortable: true },
    { Header: "Location", accessor: "location" },
    { Header: "Capacity", accessor: "capacity" },
    { Header: "Type", accessor: "tower_type" },
    { Header: "Description", accessor: "description" },
    { Header: "Height", accessor: "tower_height" },
    { Header: "Imageset", accessor: "imageCollectionCount" },
  ];

  const handleStateChange = (key, value) => {
    setGlobalState((prev) => ({ ...prev, [key]: value }));
  };

  const sidebarConfigurations = {
    options: showBackIcon
      ? [
          { icon: MenuIcon, text: "Home", path: "/picstork/dashboard" },
          { icon: TowerIcon2, text: "Projects", path: "/picstork/towers" },
        ]
      : null,
    user,
    type,
    mode: sidebarMode,
    picStorkHelp: true,
  };

  const topbarConfigurations = {
    options: showBackIcon
      ? [
          fromDashBoard && {
            icon: MenuIcon,
            text: "Dashboard",
            path: "/picstork/dashboard",
          },
          { icon: MenuIcon, text: "Projects", path: "/picstork/towers" },
          {
            icon: MenuIcon,
            text: `${rowData?.project_name}`,
            path: "/picstork/tower-plans",
            rowData: rowData,
          },
        ].filter(Boolean)
      : null,
    user,
    type,
    mode: sidebarMode,
    picStorkHelp: true,
  };

  function useDebounce(value, delay = 500) {
    const [debounced, setDebounced] = useState(value);
    useEffect(() => {
      const handler = setTimeout(() => setDebounced(value), delay);
      return () => clearTimeout(handler);
    }, [value, delay]);
    return debounced;
  }

  const debouncedKey = useDebounce(searchKey, 500);

  const getAllPlans = () => {
    setIsLoading(true);
    let key = " ";
    let projectName = rowData?.project_name;
    const id = rowData?.id;
    const pageNumber = Math.floor(tableState.pageNumber - 1);

    API.getPlans(
      projectName,
      searchKey || " ",
      tableState.pageSize || 10,
      pageNumber,
      3,
      id,
      "",
      "",
      tableState.orderBy,
      tableState.orderType,
      "all"
    ).then(
      (data) => {
        const formattedPlans = (data.plans || []).map((plan) => ({
          ...plan,
          date_and_time: plan.date_and_time
            ? new Date(plan.date_and_time).toISOString().split("T")[0]
            : "—",
        }));
        setAllPlans(formattedPlans);
        setCounts(data.count || formattedPlans.length);
        setIsLoading(false);
      },
      (e) => {
        console.log(e);
      }
    );
  };

  useEffect(() => {
    if (rowData?.project_name && rowData?.id) {
      getAllPlans();
    }
  }, [rowData, isCreateModalOpen, debouncedKey, tableState]);

  useEffect(() => {
    if (rowData?.id) {
      API.getProjectKMLURL(rowData.id)
        .then((data) => {
          setKmlUrl(data.kmlimageurl);
        })
        .catch((err) => console.error("Error fetching KML URL:", err));
    }
  }, [rowData]);

  useEffect(() => {
    if (rowData?.id) {
      API.getReportDetails(rowData.id)
        .then((data) => {
          setReportDetails(data);
        })
        .catch((err) => console.error("Error fetching URL:", err));
    }
  }, [rowData, reportDetails?.status, selectedPlan, fetchReport]);

  const downaloadLabel = reportDetails?.status === "Pending" || reportDetails?.status === "In_Progress" ? "Generating Report..." : "Download Report"

  const pollReportStatus = (projectId) => {
    const intervalId = setInterval(async () => {
      try {
        const data = await API.getReportDetails(projectId);

        if (data) {
          setReportDetails(data);
          if (data.status === "Completed" || data.status === "Failed" || data.status === "Regenerate") {
            clearInterval(intervalId);
            setFetchReport(false);
          }
        }
         if (data?.status === "Failed") {
           toast.error("Report generation failed!");
         }
      } catch (err) {
        console.error("Error while polling report status:", err);
        clearInterval(intervalId);
        setFetchReport(false);
      }
    }, 5000);

    return intervalId;
  };

  const handleRegenerateReport = async (status, showToast = true) => {
    if (!reportDetails?.id) return;

    try {
      const response = await API.updateReportStatus({
        reportId: reportDetails.id,
        status: status || "Pending",
        report_type: "Progress_Monitoring",
      });

        if (response?.report && showToast) {
          toast.success(
            "Report regeneration started! Please wait a few seconds..."
          );
        }

        if (response.error && showToast) {
          toast.error("Report regeneration failed! Please try again...");
          return;
        }

      // Update local state so the button state updates and UI reflects new status
      setReportDetails((prev) => ({
        ...prev,
        status: status || "Pending",
      }));
      pollReportStatus(rowData?.id);
    } catch (err) {
      console.error("Error while regenerating report:", err);
    }
  };

  const getButtonStates = (status, url) => {
    switch (status) {
      case "Pending":
      case "In_Progress":
        return { download: true, regenerate: true };
      case "Completed":
        return { download: false, regenerate: true };
      case "Regenerate":
        return { download: url ? false : true, regenerate: false };
      case "Failed":
        return { download: true, regenerate: false };
      default:
        return { download: true, regenerate: true };
    }
  };

  const { download, regenerate } = getButtonStates(reportDetails?.status, reportDetails?.report_url);

  const handleGenerateReport = async () => {
    try {
      const response = await API.createReport({
        type: "Progress_Monitoring",
        project_id: rowData?.id,
        plan_id: null,
        image_collection_id: null,
        status: "Pending",
      });
      if (response?.report) {
        toast.success(
          "Report generation started! Please wait a few seconds..."
        );
      }
      
      if (response.error) {
        toast.error("Report generation failed! Please try again...");
        return;
      }
      setFetchReport(true);
      pollReportStatus(rowData?.id);
    } catch (err) {
      console.error("Unexpected error:", err);
    }
  };

  return (
    <div className="wrapper">
       <Toaster
          position="top-right"
          reverseOrder={false}
          toastOptions={{
            duration: 3000,
            style: {
              fontSize: "12px",
              marginTop: "35px"
            },
          }}
        />
      <SideBarNew
        config={sidebarConfigurations}
        showMainDashboardIcons={showBackIcon}
        parentSidebarSwitch={() =>
          setSidebarMode(sidebarMode === "shrunk" ? "expanded" : "shrunk")
        }
      />

      <div
        className="right-content"
        style={{ backgroundColor: "#EAEDF0" }}
        onClick={() => setSidebarMode("shrunk")}
      >
        <TopBarNew config={topbarConfigurations} />

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            marginTop: "20px",
            padding: "20px",
          }}
        >
          <div
            className="slide"
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              width: "100%",
              alignItems: "center",
            }}
          >
            <div
              className="services-content-title"
              style={{
                display: "flex",
                alignItems: "center",
                color: "#1F1C45",
                fontWeight: 600,
              }}
            >
              Towers ({counts})
              <ButtonWithIcon
                text=""
                icon={whitePlus}
                onClick={() => setIsCreateModalOpen(true)}
                isDisabled={false}
                backgroundColor="#2989CF"
                border="1px solid #2989CF"
              />
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "7px",
                paddingRight: "8px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "7px",
                  margin: "0px 5px",
                }}
              >
                {plans.length > 0 && (
                  <>
                    {reportDetails?.error ? (
                      <ButtonWithIcon
                        text="Generate Report"
                        onClick={() => handleGenerateReport()}
                      />
                    ) : (
                      <>
                        <ButtonWithIcon
                          text={downaloadLabel}
                          onClick={() =>
                            downloadReport(
                              reportDetails?.report_url,
                              `${rowData?.project_name}PMReport.pdf`
                            )
                          }
                          isDisabled={download}
                        />

                        <ButtonWithIcon
                          text="Regenerate Report"
                          onClick={() => {
                            if(reportDetails?.report_url){
                              setShowRegeneratePopup(true);
                            } else {
                              handleRegenerateReport("Pending", true);
                            }
                          }}
                          isDisabled={regenerate}
                        />
                      </>
                    )}
                  </>
                )}
                <div style={{ position: "relative" }}>
                  <img
                    src={Search}
                    alt="Search"
                    style={{
                      height: "20px",
                      width: "20px",
                      position: "absolute",
                      left: "8px",
                      top: "50%",
                      transform: "translateY(-50%)",
                    }}
                  />
                  <input
                    type="text"
                    value={searchKey}
                    className="add-user-form-text2"
                    placeholder="Search"
                    style={{
                      height: "30px",
                      width: "230px",
                      paddingLeft: "30px",
                      border: "1px solid rgba(102, 102, 102, 0.3)",
                      borderRadius: "4px",
                    }}
                    onChange={(e) => setSearchKey(e.target.value)}
                  />
                </div>
              </div>
            </div>
          </div>

          {kmlUrl && (
            <div>
              <KMLViewer url={kmlUrl} />
            </div>
          )}

          {isLoading ? (
            <LoaderComponent />
          ) : (
            <TableView
              columns={columns}
              data={plans}
              count={counts}
              showSrNo={true}
              onStateChange={setTableState}
              pageNumber={tableState.pageNumber}
              hideDelete={true}
              activities={{
                disableDelete: true,
                canEdit: true,
                onClickEdit: (row) => {
                  {
                    setIsCreateModalOpen(true);
                    setSelectedPlan(row);
                  }
                },
              }}
              onClickRow={(row) => {
                history.push("/picstork/tower-imageset", {
                  rowData: row,
                  breadcrumb: [
                    {
                      icon: MenuIcon,
                      text: `${rowData?.project_name}`,
                      path: "/picstork/tower-plans",
                      rowData: rowData,
                    },
                    {
                      icon: MenuIcon,
                      text: `${row?.plan_name}`,
                      path: "/picstork/tower-imageset",
                      rowData: row,
                    },
                  ],
                });
              }}
            />
          )}
        </div>
      </div>
      <CreateTowerPlan
        isOpen={isCreateModalOpen}
        onRequestClose={() => {
          setIsCreateModalOpen(false);
          setSelectedPlan({});
        }}
        onSubmit={(newTower) => {
          setSelectedPlan({});
          if(isTowerPresent) {
          handleRegenerateReport("Regenerate", false);
          }
        }}
        projectData={rowData}
        editData={selectedPlan}
      />
      <Modal
        style={{ marginTop: "150px" }}
        show={showRegeneratePopup}
        onHide={() => setShowRegeneratePopup(false)}
      >
        <Modal.Body>
          <p>
            Previous version of the report will be lost by regenerating. Please
            download it if needed.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="addcustomer-button-empty-dashboard"
            onClick={() => setShowRegeneratePopup(false)}
          >
            Cancel
          </button>
          <button
            className="add-user-form-submit-button btn-ok"
            onClick={() => {
              handleRegenerateReport("Pending", true);
              setShowRegeneratePopup(false);
            }}
          >
            Regenerate
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  activesubscription: (payload) => dispatch(activesubscription(payload)),
});

const mapStateToProps = (state) => ({
  SubscriptionData: state.subscription.subscriptionData,
});

export default connect(mapStateToProps, mapDispatchToProps)(TowerPlan);
